import { formatMoney, formatSignedMoney } from './formatters';

export function buildCopyQuoteText({
    builder,
    mobilityDiscountActive,
    quote,
    selectedTv
}) {
    const tvSummary = quote.tvSelectionSummary;
    const tvRecommendationLines = tvSummary ? [
        '',
        'TV recommendation:',
        tvSummary.selectedChoices?.length ? `- Customer selected: ${tvSummary.selectedChoices.join(', ')}` : null,
        tvSummary.requiredThemePacks?.length ? `- Theme packs selected: ${tvSummary.requiredThemePacks.join(', ')}` : null,
        tvSummary.premiumChannels?.length ? `- Premium channels selected: ${tvSummary.premiumChannels.join(', ')}` : null,
        `- Best value: ${tvSummary.bestValuePackage}`,
        tvSummary.addOnCount > 0 ? `- Add-on: ${tvSummary.addOnCount} extra theme pack${tvSummary.addOnCount === 1 ? '' : 's'} (${formatMoney(tvSummary.addOnTotal)}/mo)` : null,
        tvSummary.extraValueNote ? `- Extra value: ${tvSummary.extraValueNote.replace(/^Note:\s*/i, '')}` : null,
        tvSummary.upgradeOpportunity
            ? `- Upgrade opportunity: ${tvSummary.upgradeOpportunity.packageName} for ${formatMoney(tvSummary.upgradeOpportunity.priceDiff)}/mo more${[
                tvSummary.upgradeOpportunity.extraThemes > 0 ? `${tvSummary.upgradeOpportunity.extraThemes} extra theme pack${tvSummary.upgradeOpportunity.extraThemes === 1 ? '' : 's'}` : null,
                tvSummary.upgradeOpportunity.extraPremiums > 0 ? `${tvSummary.upgradeOpportunity.extraPremiums} extra premium channel${tvSummary.upgradeOpportunity.extraPremiums === 1 ? '' : 's'}` : null
            ].filter(Boolean).length ? `, includes ${[
                tvSummary.upgradeOpportunity.extraThemes > 0 ? `${tvSummary.upgradeOpportunity.extraThemes} extra theme pack${tvSummary.upgradeOpportunity.extraThemes === 1 ? '' : 's'}` : null,
                tvSummary.upgradeOpportunity.extraPremiums > 0 ? `${tvSummary.upgradeOpportunity.extraPremiums} extra premium channel${tvSummary.upgradeOpportunity.extraPremiums === 1 ? '' : 's'}` : null
            ].filter(Boolean).join(' and ')}` : ''}`
            : null
    ].filter(Boolean) : [];
    const savingsLines = quote.savings ? [
        '',
        'Savings comparison:',
        `Current monthly bill: ${formatMoney(quote.savings.currentMonthlyBill)}/mo`,
        `New TELUS bundle: ${formatMoney(quote.monthlySubtotal)}/mo`,
        quote.savings.status === 'saves'
            ? `Customer saves ${formatMoney(quote.savings.monthlyDifference)}/mo`
            : quote.savings.status === 'more'
                ? `Customer pays ${formatMoney(Math.abs(quote.savings.monthlyDifference))}/mo more`
                : 'Similar monthly price',
        quote.savings.status === 'saves'
            ? `Estimated 2-year savings: ${formatMoney(quote.savings.twoYearDifference)}`
            : quote.savings.status === 'more'
                ? `Estimated 2-year difference: ${formatMoney(Math.abs(quote.savings.twoYearDifference))}`
                : 'Focus on fibre upgrade, price lock, and included bundle value.',
        quote.billCredit ? `2-year impact including bill credit: ${formatSignedMoney(quote.savings.twoYearImpactWithCredit)}` : null,
        quote.savings.status === 'more'
            ? 'If customer is on a temporary promo, ask when their promo ends. Compare against future regular price, fibre upgrade, upload speed, and price lock.'
            : null
    ].filter(Boolean) : [];
    const quoteItemLines = quote.items.map((item) => {
        if (item.section === 'Internet') {
            return `${item.label}: ${formatMoney(item.amount)}/mo, ${item.detail.replace(/^Includes/, 'includes')}`;
        }

        if (item.section === 'TV' && selectedTv && item.label === selectedTv.name) {
            return `TV ${item.label}: ${formatMoney(item.amount)}/mo${quote.tvPriceBreakdown?.eppDiscount > 0 ? ' after EPP discount' : ''}`;
        }

        if (item.section === 'Home Phone') {
            return `${item.label}: ${formatMoney(item.amount)}/mo${item.detail ? ` (${item.detail})` : ''}`;
        }

        return `${item.section} - ${item.label}: ${formatMoney(item.amount)}/mo${item.detail ? ` (${item.detail})` : ''}`;
    });
    const discountStatusLines = [
        builder.pabIncluded ? '- PAB included' : '- PAB not included',
        mobilityDiscountActive ? '- TELUS/Koodo mobility discount active' : null,
        builder.eppEnabled ? '- EPP closing tool active' : null,
        `- One-time bill credit: ${quote.billCredit ? formatMoney(quote.billCredit) : 'Not applied'}`
    ].filter(Boolean);

    return [
        'TELUS bundle quote',
        '',
        ...quoteItemLines,
        ...tvRecommendationLines,
        '',
        'Discounts & credits:',
        ...discountStatusLines,
        `Estimated monthly subtotal: ${formatMoney(quote.monthlySubtotal)}/mo`,
        ...savingsLines,
        '',
        'Notes:',
        ...quote.notes.map((note) => `- ${note}`),
        '- Verify serviceability, install availability, account eligibility, and final DOCX pricing before sending.'
    ].join('\n');
}
